(function () {
  'use strict';

  function initCarousel(section) {
    var carousel = section.querySelector('.bsc-carousel');
    if (!carousel) return;

    var prevBtn = section.querySelector('.bsc-arrow--prev');
    var nextBtn = section.querySelector('.bsc-arrow--next');
    var autoplay = section.dataset.autoplay === 'true';
    var autoplaySpeed = (parseInt(section.dataset.autoplaySpeed, 10) || 4) * 1000;
    var autoplayTimer = null;

    function getCardWidth() {
      var card = carousel.querySelector('.bsc-card');
      if (!card) return carousel.clientWidth * 0.8;
      var gap = parseFloat(window.getComputedStyle(carousel).gap) || 20;
      return card.offsetWidth + gap;
    }

    function atStart() {
      return carousel.scrollLeft <= 2;
    }

    function atEnd() {
      return carousel.scrollLeft >= carousel.scrollWidth - carousel.clientWidth - 2;
    }

    function updateButtons() {
      if (prevBtn) prevBtn.setAttribute('aria-disabled', atStart() ? 'true' : 'false');
      if (nextBtn) nextBtn.setAttribute('aria-disabled', atEnd() ? 'true' : 'false');
    }

    function scrollTo(position) {
      carousel.scrollTo({ left: position, behavior: 'smooth' });
    }

    function scrollNext() {
      var target = atEnd() ? 0 : Math.min(carousel.scrollLeft + getCardWidth(), carousel.scrollWidth - carousel.clientWidth);
      scrollTo(target);
    }

    function scrollPrev() {
      var target = Math.max(carousel.scrollLeft - getCardWidth(), 0);
      scrollTo(target);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (!atStart()) scrollPrev();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        scrollNext();
      });
    }

    carousel.addEventListener('scroll', updateButtons, { passive: true });

    carousel.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); scrollPrev(); }
      if (e.key === 'ArrowRight') { e.preventDefault(); scrollNext(); }
    });

    if (autoplay) {
      function startAutoplay() { autoplayTimer = setInterval(scrollNext, autoplaySpeed); }
      function stopAutoplay() { clearInterval(autoplayTimer); autoplayTimer = null; }
      section.addEventListener('mouseenter', stopAutoplay);
      section.addEventListener('mouseleave', startAutoplay);
      section.addEventListener('focusin', stopAutoplay);
      section.addEventListener('focusout', startAutoplay);
      startAutoplay();
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateButtons, 150);
    }, { passive: true });

    updateButtons();
  }

  function init() {
    document.querySelectorAll('.bsc-section').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
